module.exports = __webpack_public_path__ + "img/rueckgabe-icon-data.5e8b2936.svg";